
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { WbAccordionComponent } from './WbAccordion';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

export default (ComponentInitializeDispatcher as WbAccordionComponent).extend({
  name: 'owc-wb-accordion',
  mixins: [OwcDataComponent],
  components: {
    SlotContainer,
    ValidationBoxWrapper,
  },
  computed: {
    accordionItems: function() {
      return this.componentData?.items;
    },
    globalBackLabel: function() {
      return this.componentData?.globalBackLabel;
    },
    isDarkMode: function() {
      return Boolean(this.componentData?.darkMode);
    },
  },
  methods: {
    handleAccordionItemClick: function(index, wbItemLabel) {
      if (this.componentData?.parentTab) {
        const tabContent = this.componentData.parentTab;
        const tabLabel = `tab${tabContent.tabIndex}.${tabContent.label}`;
        const wbAccordionItemIndex = index + 1;
        const wbAccordionItemLabel = `subtab${wbAccordionItemIndex}.${wbItemLabel}`;
        const element = this.$refs.wbAccordion;

        this.handleCustomTracking(element, `${tabLabel}.${wbAccordionItemLabel}`, 'feature', 'click');
      }
    },
  },
});
